import Phaser from '../lib/phaser.js';
import { BattleMonster } from '../battle/monsters/battle-monster.js';

/**
 * @param {BattleMonster} monster
 * @returns {number}
 */
export function calculateMinValueForCapture(monster) {
  // Catch difficulty: `randomValue` (0-100) must reach this floor. Lowered from 80 and the low-HP
  // bonuses widened so weakening a beast actually pays off — at full HP it's ~31% (was 21%), and a
  // well-weakened beast (<25% HP) is ~61% (was 41%). The old curve made catching feel impossible
  // ("damage balls don't let you catch"). Guard a NaN ratio (missing maxHp) so it never hardens to 80.
  let baseMin = 70;
  const maxHp = monster.maxHp || 1;
  const healthRatio = monster.currentHp / maxHp;

  if (healthRatio < 0.25) {
    baseMin -= 30;
  } else if (healthRatio < 0.5) {
    baseMin -= 22;
  } else if (healthRatio < 0.75) {
    baseMin -= 14;
  } else if (healthRatio < 0.9) {
    baseMin -= 7;
  }

  return baseMin;
}

/**
 * @typedef CaptureMonsterResults
 * @type {object}
 * @property {number} requiredCaptureValue
 * @property {number} actualCaptureValue
 * @property {boolean} wasCaptured
 */

/**
 * @param {BattleMonster} monster
 * @param {number} [captureBonus] lowers the capture threshold (a Premium Ball passes ~20 here).
 * @returns {CaptureMonsterResults}
 */
export function calculateMonsterCaptureResults(monster, captureBonus = 0) {
  const minValueRequiredForCapture = Math.max(0, calculateMinValueForCapture(monster) - captureBonus);
  const randomValue = Phaser.Math.Between(0, 100);
  return {
    requiredCaptureValue: minValueRequiredForCapture,
    actualCaptureValue: randomValue,
    wasCaptured: randomValue >= minValueRequiredForCapture,
  };
}
